<template>
  <div id="event-wrapper">
    <app-header></app-header>

    <div class="container">
      <h2 class="event-name">{{ event.name }} "{{ event.theme }}"</h2>
      <div class="event-date">{{ (new Date(event.date)).toDateString() }}</div>
      <div class="row">
        <div class="col-lg-5 col-md-12">
          <img class="event-img" v-bind:src="event.img">
        </div>
        <div class="col-lg-7 col-md-12">
          <ul class="event-info">
            <li>
              <img class="icon" src="../assets/icons/calendar.png">
              {{ (new Date(event.date)).toDateString() }}
            </li>
            <li>
              <img class="icon" src="../assets/icons/compass.png">
              {{ event.place }}
            </li>
            <li v-if="event.album">
              <img class="icon" src="../assets/icons/picture.png">
              <a :href="event.album.url">{{ event.album.name }}</a>
            </li>
            <li v-if="event.message" v-html=event.message class="event-message"></li>
          </ul>
        </div>
      </div>

      <div class="google-map">
        <iframe
          v-if="event.google_map"
          v-bind:src="event.google_map"
          width="80%"
          height="320" frameborder="0" style="border:0"
          allowfullscreen></iframe>
      </div>

      <div v-if="event.announce" v-html="event.announce" class="event-announce"></div>

    </div>

    <div class="container event-speaker">
      <h2>Speakers</h2>
      <speaker-list :speakers="speakers"></speaker-list>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SpeakerList from '@/components/SpeakerList';
import EventsData from '@/assets/events.json';
import SpeakersData from '@/assets/speakers.json';


export default {
  name: 'Event',
  components: {
    'app-header': Header,
    'app-footer': Footer,
    'speaker-list': SpeakerList,
  },
  data() {
    return {
      event: EventsData[this.$route.params.key],
      speakers: SpeakersData[this.$route.params.key],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/global";

#event-wrapper {
  margin-top: 96px;
  padding: 0;
}

.event-name {
  font-size: 40px;
  font-weight: bolder;
  margin: 0 10px;
  color: $brand-darker;
}

.event-date {
  font-size: 20px;
  color: $brand-primary;
  font-weight: bolder;
  margin: 0 12px 16px 12px;
}

.event-img {
  display: block;
  margin: 0 auto;
  width: 100%;
  max-height: 400px;
  object-fit: contain;

  @include media-breakpoint-down(md) {
    max-height: 360px;
  }
}

.icon {
  height: 24px;
  margin: 0 8px 4px 0;
}

.event-info {
  font-size: 20px;
  list-style: none;
  margin: 12px 0 8px 0;
  padding: 8px 8px 0 0;

  li {
    margin: 4px 0;
    vertical-align: bottom;
  }

  .event-message {
    margin: 12px 0 16px 4px;
    font-size: 16px;
  }
}

.google-map {
  padding: 24px;
  iframe {
    width: 80%;
    height: 400px;

    @include media-breakpoint-down(md) {
      width: 96%;
      height: 300px;
    }
  }
}

.event-announce {
  margin: 12px 24px;

  @include media-breakpoint-down(sm) {
    margin: 12px 16px;
  }
}

.event-speaker {
  width: 100%;
  margin-top: 40px;

  h2 {
    margin: 0 0 4px 24px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Event.vue